import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthenticationService} from "../../services/authentication.service";
import {AppRoutes} from "../../constants/app-routes";

export const authGuard: CanActivateFn = (route, state) => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);
  if(authenticationService.isLoggedIn()) {
    return true;
  }
  return router.navigate([AppRoutes.LOGIN_ROUTE]);
};
